
import React from "react";

function RoundedIconButton(props) {
    const color = props.color;
    const icon = props.icon;
    let defaultClassNames = `inline-flex items-center p-2 sm:p-3 border border-transparent rounded-full shadow-sm text-white bg-${color}-600 hover:bg-${color}-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${color}-500`;
    if (props.className) {
        defaultClassNames += " " + props.className
    }
    return (
        <button onClick={props.onClick} type="button" className={defaultClassNames}>
            {React.cloneElement(icon, { className: "h-5 w-5"})}
        </button>
    )
}

export default RoundedIconButton;